// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/sales/point-of-sale/${file}.vue`
  );

export default [
  {
    path: "/point-of-sale/create",
    name: "point-of-sale-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "PointOfSale",
    },
    components: {
      content: lazyLoad("point-of-sale"),
    },
  },
  {
    path: "/point-of-sale-history",
    name: "point-of-sale-history",
    meta: { requiresAuth: true, applicationFeatureCode: "PointOfSale" },
    components: {
      content: lazyLoad("point-of-sale-history"),
    },
  },
  {
    path: "/point-of-sale-detail/review/:id",
    name: "point-of-sale-detail-review",
    meta: { requiresAuth: true, applicationFeatureCode: "PointOfSale" },
    components: {
      content: lazyLoad("point-of-sale-detail"),
    },
  },
  {
    path: "/point-of-sale-detail/edit/:id",
    name: "point-of-sale-detail-edit",
    meta: { requiresAuth: true, applicationFeatureCode: "PointOfSale" },
    components: {
      content: lazyLoad("point-of-sale-detail"),
    },
  },
];
